<template>
  <van-popup
    :value="visible"
    position="bottom"
    get-container="body"
    class="record-pop"
    @open="resetForm"
  >
    <div>
      <van-nav-bar :title="'农资'+stockType" :border="false" left-arrow @click-left="$emit('update:visible', false)" />
      <van-form ref="form" input-align="right" error-message-align="right">
        <van-field label="农资" input-align="left">
          <template #input>
            <agr-box :agr-data="agrData" :editable="false" />
          </template>
        </van-field>
        <van-field :value="agrData|agrUnitFilter" readonly label="包装规格" />
        <van-field label="当前库存">
          <template #input>
            <div class="primary-color">
              {{ agrData | agrCountFilter }}（共{{ agrData | agrTotalFilter }}）
            </div>
          </template>
        </van-field>
        <van-field
          :value="form.changeCount"
          :rules="rules.changeCount"
          :label="stockType+'数量'"
        >
          <template #input>
            <van-stepper
              v-model.number="form.changeCount"
              :min="0"
              :max="stockType==='出库'?agrData.count:Infinity"
              input-width="80px"
              decimal-length="1"
            />
          </template>
          <template #extra>
            <span style="margin: 0 10px;color: #BBB;">{{ agrData.pack }}</span>
          </template>
        </van-field>
        <wh-field-select-popup
          v-model="form.changeType"
          :label="stockType+'类型'"
          :columns="changeTypeOptions"
          :rules="rules.changeType"
        />
        <wh-field-time-popup
          v-model="form.inputDate"
          :label="stockType+'时间'"
          :rules="rules.inputDate"
        />
        <wh-field-select-popup
          v-model="form.operator"
          :columns="operatorOptions"
          :rules="rules.operator"
          label="负责人"
        />
        <van-field
          v-model="form.note"
          label="备注"
          maxlength="180"
          autosize=""
          rows="1"
          type="textarea"
          show-word-limit
        />
      </van-form>
      <div style="height: 80px;" />
    </div>
    <div style="position: relative">
      <wh-sub-button style="margin-top: 40px;" @click="handleSub" />
    </div>
  </van-popup>
</template>

<script>
import { agrCountFilter, agrTotalFilter, agrUnitFilter } from '@/filter'
import WhFieldSelectPopup from '@/components/public/WhFieldSelectPopup/WhFieldSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import dayjs from 'dayjs'
import api from '@/api'
import WhSubButton from '@/components/base/WhSubButton'
import AgrBox from '@/views/agrStock/components/AgrBox'

export default {
  name: 'AgrManage',
  components: { AgrBox, WhSubButton, WhFieldTimePopup, WhFieldSelectPopup },
  filters: {
    agrUnitFilter, agrCountFilter, agrTotalFilter
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agrData: {
      type: Object,
      default() {
        return {}
      }
    },
    stockType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      operatorOptions: [],
      form: {
        changeCount: '',
        changeType: '',
        inputDate: dayjs().format('YYYY-MM-DD HH:mm:00'),
        operator: '',
        note: ''
      },
      rules: {
        changeCount: [
          { required: true, validator: val => !!val, message: '请填写数量' }
        ],
        changeType: [
          { required: true, message: '请选择库存操作类型' }
        ],
        inputDate: [
          { required: true, message: '请选择时间' }
        ],
        operator: [
          { required: true, message: '请选择负责人' }
        ]
      }
    }
  },
  computed: {
    changeTypeOptions() {
      switch (this.stockType) {
        case '入库':
          return ['采购入库', '调拨入库', '盘盈入库', '其他入库']
        case '出库':
          return ['盘亏出库', '调拨出库', '报废出库', '其他出库']
        default:
          return []
      }
    }
  },
  methods: {
    resetForm() {
      this.getStaffList()
      this.form = {
        changeCount: '',
        changeType: '',
        inputDate: dayjs().format('YYYY-MM-DD HH:mm:00'),
        operator: '',
        note: ''
      }
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    getStaffList() {
      api.getStaffList({ pageSize: 1000 }).then(({ data: { list }}) => {
        this.operatorOptions = list.map(i => {
          return i.name
        })
      })
    },
    handleSub() {
      this.$refs.form.validate().then(() => {
        const query = {
          agriculturalId: this.agrData.id,
          recordType: this.stockType,
          ...this.form
        }
        query.changeCount = this.agrData.num * 1000 * query.changeCount
        api.createAgriculturalRecord(query).then(() => {
          this.$toast(`${this.stockType}成功`)
          this.$emit('success')
          this.$emit('update:visible', false)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.record-pop {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  flex-direction: column;
}
.primary-color {
  color: @primary-color;
}
</style>
